import { useMediaQuery } from "@repo/common/hooks/use-media-query";
import { MOBILE_BREAKPOINT_PX } from "@repo/common/constants";

export function useMobileSize() {
  const isMobile = useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT_PX}px)`);

  return isMobile;
}
